export const initProjectsSplide = () => {
    // Splideライブラリがロードされているかチェック
    if (typeof Splide === 'undefined') {
        console.error('Splide library is not loaded');
        return;
    }

    // Splide要素の存在確認
    const splideElement = document.querySelector('.p-top-projects__splide');
    if (!splideElement) {
        console.error('Splide element not found');
        return;
    }

    // 既存のSplideがあれば先に破棄
    if (splideElement.splide) {
        try {
            splideElement.splide.destroy();
        } catch (error) {
            // エラーは無視して続行
        }
        // 参照をクリア
        splideElement.splide = null;
    }

    const isMobile = window.innerWidth <= 768;

    const projectsSplide = new Splide('.p-top-projects__splide', {
      type: isMobile ? 'slide' : 'loop',
      rewind: isMobile ? true : false,
      autoWidth: true,
      focus: 'center',
      gap: isMobile ? '16px' : '24px',
      drag: true,
      autoplay: isMobile ? false : true,
      pauseOnHover: true,
      pauseOnFocus: true,
      waitForTransition: false,
      pagination: false,
      arrows: false,
      lazyLoad: 'sequential',
    });

    // 初期化
    projectsSplide.mount();

    // メモリリーク対策：ページ離脱時にSplideインスタンスを破棄（重複防止）
    if (!window.splideBeforeUnloadAdded) {
        window.addEventListener('beforeunload', () => {
            // 全てのSplideインスタンスを破棄
            document.querySelectorAll('.p-top-projects__splide').forEach(element => {
                if (element.splide) {
                    element.splide.destroy();
                }
            });
        });
        window.splideBeforeUnloadAdded = true;
    }

    // DOMにインスタンスを保存（プロジェクトフィルターで使用）
    splideElement.splide = projectsSplide;

    return projectsSplide;
};

// ページバック時の処理（ブラウザのキャッシュから復元された場合）
if (!window.splidePageshowAdded) {
    window.addEventListener('pageshow', (event) => {
        // ブラウザキャッシュからの復元時（戻るボタン）
        if (event.persisted) {
            const mainElement = document.querySelector('main');
            const pageId = mainElement ? mainElement.getAttribute('id') : null;

            // Splideが必要なページの場合、少し遅延させて再初期化
            const splidePages = ['top', 'business-field', 'project-portfolio-single'];
            if (pageId && splidePages.includes(pageId)) {
                setTimeout(() => {
                    initProjectsSplide();
                }, 100); // CSSが確実に適用された後に初期化
            }
        }
    });
    window.splidePageshowAdded = true;
}
